import { render, staticRenderFns } from "./PieChartWithoutLabel.vue?vue&type=template&id=ca660ae6&scoped=true"
import script from "./PieChartWithoutLabel.vue?vue&type=script&lang=js"
export * from "./PieChartWithoutLabel.vue?vue&type=script&lang=js"
import style0 from "./PieChartWithoutLabel.vue?vue&type=style&index=0&id=ca660ae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca660ae6",
  null
  
)

export default component.exports